import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation createChildOrganization($data: createChildOrganizationInput!) {
    createChildOrganization(data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const createChildOrganizationRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.CreateChildOrganizationInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/create_child_organization',
  async (
  params: {data: TYPES.CreateChildOrganizationInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.createChildOrganization;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const createChildOrganizationSlice = createSlice({
  name: 'create_child_organization',
  initialState: initialState,
  reducers: {
    createChildOrganizationClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(createChildOrganizationRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(createChildOrganizationRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(createChildOrganizationRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { createChildOrganizationClear } =
createChildOrganizationSlice.actions;

export const createChildOrganization = createSelector(
  (state: RootState) => state.organization.createChildOrganization.result,
  (state: RootState) => state.organization.createChildOrganization.error,
  (state: RootState) => state.organization.createChildOrganization.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default createChildOrganizationSlice.reducer;